<template>
  <div class="details_form_item">
    <Form ref="editModel" :model="editModel" :label-width="120">
      <FormItem label="权限名称：">{{editModel.privilegeName}}</FormItem>
      <FormItem label="权限值：">{{editModel.privilegeCode}}</FormItem>
      <FormItem
        label="权限类型："
      >{{$common.getEnumDescription("privilegeType", editModel.privilegeType)}}</FormItem>
      <FormItem label="描述信息：">{{editModel.privilegeDescription}}</FormItem>
      <FormItem label="创建人：">{{editModel.createUser}}</FormItem>
      <FormItem label="创建时间：">{{$common.parseDate(editModel.createTime)}}</FormItem>
    </Form>
     <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["editModelTemp"],
  data: function () {
    return {
      editModel: {
      },
    };
  },

  created: function () {
    this.editModel = this.editModelTemp;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>